import { v4 as uuidv4 } from 'uuid'

import {
  NAME,
  BUDGET,
  SOCIAL_MEDIA_POST,
  BRAND_KEYWORDS,
  INCLUDE_LINKED_INSTAGRAM_ACCOUNT,
  LINKED_INSTAGRAM_ACCOUNT
} from '../../../fields'

export const initialValues = {
  [NAME]: '',
  [BUDGET]: '',
  [SOCIAL_MEDIA_POST]: '',
  [BRAND_KEYWORDS]: [{ text: '', id: uuidv4() }],
  [LINKED_INSTAGRAM_ACCOUNT]: '',
  [INCLUDE_LINKED_INSTAGRAM_ACCOUNT]: true
}
